import { jwtDecode } from "jwt-decode";

interface KeycloakToken {
  sub: string;
  email?: string;
  name?: string;
  preferred_username?: string;
  given_name?: string;
  family_name?: string;
  realm_access?: {
    roles?: string[];
  };
}

export function getRoleKeyCloak(token: string): string[] {
  const decoded = jwtDecode<KeycloakToken>(token);
  return decoded?.realm_access?.roles || [];
}

export function getUserProfileKeyCloak(token: string) {
  const decoded = jwtDecode<KeycloakToken>(token);

  return {
    id: decoded.sub,
    username: decoded.preferred_username,
    fullName: decoded.name || `${decoded.family_name || ""} ${decoded.given_name || ""}`.trim(),
    email: decoded.email,
    roles: decoded?.realm_access?.roles || [],
  };
}
